import React from 'react';
import Icon from 'components/UI/Icon';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';
import * as styles from './PersonalData.module.scss';

export default function PersonalData({ photo, name, linkedin, position, company, companyLink }) {
  return (
    <figure className={styles.wrapper} key={name}>
      <LazyImage className={styles.photo} src={photo} alt={name ?? 'Person'} aria-hidden={true} />
      <figcaption className={styles.caption}>
        {name &&
          (linkedin ? (
            <Link href={linkedin} className={styles.name}>
              {name}
              <Icon name="linkedin-square" className={styles.linkedinIcon} />
            </Link>
          ) : (
            <p className={styles.name}>{name}</p>
          ))}
        <p className={styles.position}>
          {position}{' '}
          {companyLink ? (
            <Link href={companyLink} className={styles.companyLink}>
              {company}
            </Link>
          ) : (
            <span>{company}</span>
          )}
        </p>
      </figcaption>
    </figure>
  );
}
